var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Typography, Stack, Card, Box, Divider, FormLabel, FormControl, Input, Link, Chip, Button } from '@mui/joy';
import Icon from '../../../../../../components/ui/Icon';
import { useEffect, useRef, useState } from 'react';
import { useTwilio } from '../../../../../../data/hooks/useTwilio';
import { useWebsite } from '../../../../../../data/hooks/useWebsite';
import { useRequest } from '../../../../../../hooks/useRequest';
export default function Twilio(props) {
    var _this = this;
    var flow = props.flow;
    var isInitialMount = useRef(true);
    var _a = useState(""), twilioWebhookUrl = _a[0], setTwilioWebhookUrl = _a[1];
    var getTwilioWebhookUrl = useTwilio().getTwilioWebhookUrl;
    var limitation = useWebsite().limitation;
    var request = useRequest();
    var handleCopyClick = function () {
        navigator.clipboard.writeText(twilioWebhookUrl);
    };
    var manageBilling = function () { return __awaiter(_this, void 0, void 0, function () {
        var response, url;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, request.post('/payments/portal/session?customerId=' + (limitation === null || limitation === void 0 ? void 0 : limitation.stripeCustomerId))];
                case 1:
                    response = _a.sent();
                    url = response.data.url;
                    window.location.href = url;
                    return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        if (isInitialMount.current) {
            var fetchTwilioWebhookUrl = function () { return __awaiter(_this, void 0, void 0, function () {
                var url;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, getTwilioWebhookUrl(flow.id)];
                        case 1:
                            url = _a.sent();
                            setTwilioWebhookUrl(url);
                            return [2 /*return*/];
                    }
                });
            }); };
            fetchTwilioWebhookUrl();
            isInitialMount.current = false;
        }
    }, []);
    return (_jsxs(Card, { children: [_jsx(Box, __assign({ sx: { mb: 1 } }, { children: _jsxs(Box, __assign({ sx: { display: 'flex', justifyContent: 'space-between', alignItems: 'center' } }, { children: [_jsxs(Stack, __assign({ spacing: 1, sx: { display: 'flex', flexDirection: 'column', alignItems: 'flex-start' } }, { children: [_jsxs(Box, __assign({ sx: { display: 'flex', alignItems: 'center' } }, { children: [_jsx(Icon, { name: "twilio", size: 20 }), _jsx(Typography, __assign({ level: "title-md", sx: { ml: 1 } }, { children: "Twilio" })), _jsx(Chip, __assign({ sx: { ml: 1 }, color: "primary" }, { children: "Voice" }))] })), _jsx(Stack, __assign({ spacing: 2, sx: { pr: 2 } }, { children: _jsxs(Typography, __assign({ level: "body-sm" }, { children: ["Connect the AI Agent to any Twilio phone number.", _jsx(Link, __assign({ sx: { ml: 1 } }, { children: "Learn More" }))] })) }))] })), limitation && limitation.plan !== 'Pro' &&
                            _jsx(Button, __assign({ color: "neutral", variant: "soft", onClick: manageBilling }, { children: "Upgrade to Pro" }))] })) })), limitation && limitation.plan === 'Pro' &&
                _jsxs(_Fragment, { children: [_jsx(Divider, {}), _jsx(Stack, __assign({ spacing: 2, sx: { my: 1 } }, { children: _jsxs(Stack, __assign({ spacing: 1 }, { children: [_jsx(FormLabel, { children: "Webhook URL" }), _jsx(Typography, __assign({ level: "body-sm" }, { children: "Copy this URL and set it as the Webhook URL in the Twilio phone number configuration." })), _jsx(FormControl, __assign({ sx: { display: { sm: 'flex-column', md: 'flex-row' }, gap: 2 } }, { children: _jsx(Input, { size: "sm", value: twilioWebhookUrl, readOnly: true, variant: "soft", color: "neutral", endDecorator: _jsx(Button, __assign({ variant: "soft", color: "neutral", onClick: handleCopyClick }, { children: "Copy" })) }) }))] })) }))] })] }));
}
